import { createContext, useContext, useState } from "react";

const CallToActionContext = createContext<{
  callback: { onApplyClick: any; onResetClick: any };
  setCallback: any;
  showClearFormButton: boolean;
  setShowClearFormButton: any;
}>(undefined!);

const CallToActionProvider = ({ children }: any) => {
  const [callback, setCallback] = useState<any>();
  const [showClearFormButton, setShowClearFormButton] = useState<any>(false);

  return <CallToActionContext.Provider value={{ callback, setCallback, showClearFormButton, setShowClearFormButton }}>{children}</CallToActionContext.Provider>;
};

export const useCallToAction = () => useContext(CallToActionContext);
export default CallToActionProvider;
